var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{class:_vm.isXs?'rounded-lg ma-5':'rounded-lg mt-5 mb-5 mx-16',attrs:{"cycle":"","height":_vm.isXs?100:300,"hide-delimiter-background":"","hide-delimiters":"","show-arrows":false}},_vm._l((_vm.items),function(item){return _c('v-carousel-item',{attrs:{"href":item.link,"target":"_blank","src":item.image}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }